import React, { FunctionComponent } from 'react';

import { useFeatureFlag } from '@trello/feature-flag-client';
import { AtlassianAccountOnboardingBannerV2 } from './AtlassianAccountOnboardingBannerV2';
import { AtlassianAccountOnboardingBanner } from './AtlassianAccountOnboardingBanner';

export const AtlassianAccountOnboardingBannerWrapper: FunctionComponent = () => {
  const useV2Banner = useFeatureFlag(
    'aaaa.atlassian-access-choose-your-own-onboarding-flow-2-0',
    false,
  );
  if (useV2Banner) {
    return <AtlassianAccountOnboardingBannerV2 />;
  }
  return <AtlassianAccountOnboardingBanner />;
};
